<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="logo-container">
    <img height="48" src="../../../assets/vmware-carbon-black.png" alt="VMware Carbon Black Logo">
</div>
<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fAPI}}</mat-label>
                <input matInput id="api_url" type="text"formControlName="api_url" placeholder="{{fAPI}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fSIEM}}</mat-label>
                <input matInput id="siem_api_id" type="text" formControlName="siem_api_id" placeholder="{{fSIEM}}">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fSecret}}</mat-label>
                <input matInput id="siem_secret_key" type="password" formControlName="siem_secret_key" placeholder="{{fSecret}}">
            </mat-form-field>
        </div>

        <div>
            <button type="button" (click)="validate()" mat-raised-button>{{fValidate}}</button>
        </div>

        <div class="severity-level-wrapper">
            <div class="severity-level-input">
                <div class="severity-level-text-wrapper">
                    <label for="watchlist_severity" class="severity-level-text">
                        {{fWActiveLock}}
                    </label>
                </div>
                <mat-form-field class="severity-level" appearance="outline">
                    <input matInput id="watchlist_severity" type="number" name="watchlist_severity" formControlName="watchlist_severity" placeholder="">
                </mat-form-field>
            </div>
            <div class="severity-level-input">
                <div class="severity-level-text-wrapper">
                    <label for="policy_severity" class="severity-level-text">
                        {{fPActiveLock}}
                    </label>
                </div>
                <mat-form-field class="severity-level" appearance="outline">
                    <input matInput id="policy_severity" name="policy_severity" type="number" formControlName="policy_severity" placeholder="">
                </mat-form-field>
            </div>
        </div>

        <div class="section">
            <mat-radio-group [formControl]="formGroup.controls.lock_option" aria-label="Select what happens when a threat is received.">
                <div>
                    <mat-radio-button value="device_only">{{fLockA}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="device_sets">{{fLockB}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button value="all_devices">{{fLockC}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <div class="section">
            <mat-checkbox [formControl]="formGroup.controls.admin_unlock" matTooltip="Coming Soon">{{fAdmin}}</mat-checkbox>
        </div>
        
        <button type="button" (click)="cancel()" mat-raised-button>{{fCancel}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{fSave}}</button>

    </form>
</div>
